<template>
  <component :is="templates.indexComponents" :recharge="rechargeType"/>
</template>

<script setup>
//设置请求路径模板
import {computed, onMounted} from "vue";
import {useRoute} from "vue-router";
import store from "@/store";
import {templateList} from "@/utils/const";
import router from "@/router";
import {$_ajax} from "@/utils/axiosApi";
import {Base64} from "js-base64";

let route = useRoute()
const templates = computed(() => {
  const type = store.state.ticketTpl || "sams"
  const value = templateList[type]
  if (!value) return {}
  document.title = value.name
  return value
})
// const recharge = computed(() => store.state.rechargeType)
const rechargeType = computed(() => store.state.rechargeType)
onMounted(() => {
  store.commit("getTicketTpl", route.query.template)
  store.commit("getRechargeType", route.query.recharge)
  route.query.t ? store.commit("getQjfToken", route.query.t) : store.commit("removeQjfToken")
  // if (route.query.t){
  //   store.commit("getQjfToken", route.query.t)
  // }
  if (route.query.from) {
    store.commit("setOrderFrom", route.query.from)
  }
  if (Object.keys(templates.value) < 1) {
    store.commit("removeTicketTpl")
    router.replace({name: "404", query: {message: "非法数据请求"}})
  }
  if (rechargeType.value === "scal" && route.query.customerId) {
    //校验单点登录
    const query = route.query;
    $_ajax.get(`${process.env.VUE_APP_ONE_WAY}scal/check`, {params: query}).then(({data}) => {
      if (data.data) {
        data.data.phoneNumber = Base64.decode(data.data.phoneNumber)
        store.commit("getUser", data.data)
      } else {
        store.commit("removeUser")
      }
    }).catch(() => store.commit("removeUser"))
  }
})
</script>

<style lang="less" scoped>
.banner {
  height: 140px;
}
</style>
